export const TREATMENT_PLAN_HISTORY = 0;
export const TREATMENT_PLAN = 0;
